@if (visible) {
<button
    mat-icon-button
    type="button"
    [matMenuTriggerFor]="alertsMenu"
    [attr.aria-label]="items.length ? items.length + ' alertas de integração' : 'Sem alertas de integração'"
    [matBadge]="items.length"
    [matBadgeHidden]="!items.length"
    matBadgeColor="warn"
    matBadgeSize="small"
>
    <mat-icon>{{ items.length ? 'notifications_active' : 'notifications' }}</mat-icon>
</button>
<mat-menu #alertsMenu="matMenu" class="alerts-menu">
    <div class="alerts-head" (click)="$event.stopPropagation()">Integração SRG-SCL</div>
    @if (state === 'error') {
    <div class="alerts-empty" (click)="$event.stopPropagation()">Não foi possível atualizar os alertas.</div>
    } @else if (!items.length) {
    <div class="alerts-empty" (click)="$event.stopPropagation()">Nenhum alerta no momento.</div>
    } @else { @for (i of items; track $index) {
    <a mat-menu-item routerLink="/integration-monitor">
        <mat-icon>warning_amber</mat-icon>
        <span class="alerts-text"><b>{{ i.tenantId }}</b><br />{{ i.label }}</span>
    </a>
    } }
    <a mat-menu-item routerLink="/integration-monitor">
        <mat-icon>open_in_new</mat-icon>
        <span>Abrir central de integração</span>
    </a>
</mat-menu>
}
